import storage from '@/utils/storage'

export function v2Enabled () {
  return storage.getItem('bb_v2_enabled') === '1'
}
